// src/components/Header.jsx (ACTUALIZADO CON ICONO PRO)
import React from 'react';

const Header = () => (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
        <div className="container-fluid">
            <a className="navbar-brand" href="/">
                <i className="bi bi-graph-up-arrow me-2 text-light"></i>ICAR
            </a>
            <div className="navbar-nav ms-auto">
        <span className="navbar-text">
          {/*<i className="bi bi-wallet2 me-2"></i>PancakeSwap V3 Positions*/}
        </span>
            </div>
        </div>
    </nav>
);

export default Header;